import { Label } from "@/components/ui/label";

export type TimeValue = {
  hour: string;
  minute: string;
  period: string;
};

type TimeSelectorProps = {
  timeValue: TimeValue;
  onChange: (value: TimeValue) => void;
  label: string;
};

const selectClassName =
  "flex h-9 w-20 rounded-md border border-input bg-background px-2 py-1 text-sm ring-offset-background focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2";

const TimeSelector = ({ timeValue, onChange, label }: TimeSelectorProps) => {
  return (
    <div className="flex flex-col gap-2">
      <Label className="text-sm font-medium">{label}</Label>
      <div className="flex items-center gap-2">
        <select
          value={timeValue.hour}
          onChange={(e) => onChange({ ...timeValue, hour: e.target.value })}
          className={selectClassName}
        >
          {Array.from({ length: 12 }, (_, i) => i + 1).map((hour) => (
            <option key={hour} value={hour.toString()}>
              {hour}
            </option>
          ))}
        </select>
        <span>:</span>
        <select
          value={timeValue.minute}
          onChange={(e) => onChange({ ...timeValue, minute: e.target.value })}
          className={selectClassName}
        >
          <option value="00">00</option>
          <option value="30">30</option>
        </select>
        <select
          value={timeValue.period}
          onChange={(e) => onChange({ ...timeValue, period: e.target.value })}
          className={selectClassName}
        >
          <option value="AM">AM</option>
          <option value="PM">PM</option>
        </select>
      </div>
    </div>
  );
};

export default TimeSelector;
